import compareAsc from 'date-fns/compareAsc'

export const validateRange = (value: Date | null | undefined, fromDate?: Date, toDate?: Date) => {
  if (value) {
    if (fromDate) {
      const isValidByStartDate = compareAsc(value, fromDate) > -1
      if (!isValidByStartDate) {
        return null
      }
    }

    if (toDate) {
      const isValidByEndDate = compareAsc(value, toDate) < 1
      if (!isValidByEndDate) {
        return null
      }
    }

    return value
  }

  return null
}
